import { render } from "./PublicacionesDashboard.vue?vue&type=template&id=02e32edb"
import script from "./PublicacionesDashboard.vue?vue&type=script&lang=js"
export * from "./PublicacionesDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__